// import Vue from 'vue'
// import store from '../store/index'

// const appStoreList = ['QUERY_INSTALL_APP_INFO']
// const hasAuthorityFn = (operateCode, location) => {
//   const isAppStoreAuthority = location === 'appStore' && !appStoreList.includes(operateCode)
//   const authorityInterfaceList = location && isAppStoreAuthority
//     ? store.state.authorityModule[location] &&
//       store.state.authorityModule[location].authorityInterfaceList
//     : store.state.authorityModule.authorityInterfaceList
//   if (authorityInterfaceList) {
//     return !!authorityInterfaceList.find((item) => item.operateCode === operateCode)
//   }
//   return false
// }
// const isAppStoreFn = (route) => {
//   const matched = route && route.matched
//   if (!matched || !Array.isArray(matched) || matched.length === 0) return false
//   return matched && matched.some((item) => item.name === 'app-store')
// }
// Vue.prototype.$hasAuthority = hasAuthorityFn
// Vue.prototype.$isAppStore = isAppStoreFn
// Vue.prototype.$setAuthorityUrl = (request, route) => {
//   if (isAppStoreFn(route)) {
//     // 区分后台公开和应用内资源数据
//     const appResouce = Vue.prototype.$base64.encode(
//       JSON.stringify({
//         appId: route.query.appId
//       })
//     )
//     return request.url + '?SECURITY_INFO=' + appResouce
//   } else {
//     return request.url
//   }
// }
// Vue.directive('hasAuthority', {
//   inserted: (el, binding, vnode) => {
//     const vm = vnode.context
//     const status = isAppStoreFn(vm.$route)
//     let location
//     const value = binding.value
//     if (status) {
//       location = 'appStore'
//     }
//     // if (!hasAuthorityFn(value, location)) {
//     //   el.parentNode.removeChild(el)
//     // }
//     if (!hasAuthorityFn(value, location)) {
//       const comment = document.createComment(' ')
//       Object.defineProperty(comment, 'setAttribute', {
//         value: () => undefined
//       })
//       vnode.elm = comment
//       vnode.text = ' '
//       vnode.isComment = true
//       vnode.context = undefined
//       vnode.tag = undefined
//       vnode.data.directives = undefined
//       if (vnode.componentInstance) {
//         vnode.componentInstance.$el = comment
//       }
//       if (el.parentNode) {
//         el.parentNode.replaceChild(comment, el)
//       }
//     }
//   }
// })

const ADMIN_MENU_TREE = [
  {
    index: 'banner',
    name: 'Banner管理',
    icon: 'menu6',
    code: 'banner'
  },
  {
    index: 'productCenter',
    name: '产品中心',
    icon: 'menu0',
    code: 'productCenter'
  },
  {
    index: 'maintenance',
    name: '维保服务',
    icon: 'menu1',
    code: 'maintenance'
  },
  {
    index: 'academy',
    name: '桥弘学院',
    icon: 'menu2',
    code: 'academy'
  },
  {
    index: 'download',
    name: '资料下载',
    icon: 'menu3',
    code: 'download'
  },
  {
    index: 'spareParts',
    name: '备件服务',
    icon: 'menu4',
    code: 'spareParts'
  },
  {
    index: 'aboutUs',
    name: '关于我们',
    icon: 'menu5',
    code: 'aboutUs'
  }
]

export {
  ADMIN_MENU_TREE
}
